// extracted by mini-css-extract-plugin
module.exports = {"root":"Bold_root__LhdK3"};